import React from 'react'

const NoList = () => {
    return (
        <div className='py-5 text-center'>등록된 리스트가 없습니다.</div>
    )
}

export default NoList